var baseURL, wsURL;

if(process.env.NODE_ENV == "development") {
   // baseURL = 'http://192.168.20.230:8080/dnnCloud/interface'; 
   baseURL = '/api' 
}else if(process.env.NODE_ENV == "test"){
   // baseURL = 'http://61.132.52.38:8001/dnnCloud/interface';  
   baseURL = 'http://58.213.48.52:7899/dnnCloud/interface'  // 测试
}else {
   // baseURL = 'http://106.14.238.88:8080/dnnCloud/interface';
   baseURL = "https://dev.eicad.net/dnnCloud/interface"
}

export {
  baseURL,
  wsURL
}



// WEBPACK FOOTER //
// ./src/api/config.js